import * as types from "../actions/types";



const initialState = {
  videoConfigList: []
};


export default function video_config(state = initialState, action) {
  switch (action.type) {
    case types.SET_VIDEO_CONFIG_LIST:
      return {
        ...state,
        videoConfigList: action.payload,
      };
    case types.SET_VIDEO_CONFIG_ID:
      return {
        ...state,
        videoConfig: action.payload,
      };
    case types.SET_VIDEO_CONFIG_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
}